export const goodsTypes = Object.freeze([
  { id: 1, desc: "PRODOTTI DELL' AGRICOLTURA, DELLA CACCIA E DELLA SILVICOLTURA" },
  { id: 2, desc: 'CARBONI FOSSILI E LIGNITI' },
  { id: 3, desc: 'MINERALI METALLIFERI ED ALTRI PRODOTTI DELLE MINIERE E DELLE CAVE' },
  { id: 4, desc: 'PRODOTTI ALIMENTARI, BEVANDE E TABACCHI' },
  { id: 5, desc: "PRODOTTI DELL' INDUSTRIA TESSILE E DELL' INDUSTRIA DELL' ABBIGLIAMENTO" },
  {
    id: 6,
    desc: 'LEGNO E PRODOTTI IN LEGNO E SUGHERO (ESCLUSI I MOBILI), ARTICOLI DI PAGLIA E MATERIALI DA INTRECCIO',
  },
  { id: 7, desc: 'COKE E PRODOTTI PETROLIFERI RAFFINATI.' },
  { id: 8, desc: 'PRODOTTI CHIMICI E FIBRE SINTETICHE E ARTIFICIALI' },
  {
    id: 9,
    desc: 'ALTRI PRODOTTI DELLA LAVORAZIONE DI MINERALI NON METALLIFERI',
  },
  { id: 10, desc: 'METALLI' },
  { id: 11, desc: 'MACCHINE ED APPARECCHI MECCANICI' },
  { id: 12, desc: 'MEZZI DI TRASPORTO' },
  { id: 13, desc: 'MOBILI' },
  { id: 14, desc: 'MATERIE PRIME SECONDARIE' },
  { id: 15, desc: 'POSTA, PACCHI' },
  {
    id: 16,
    desc: 'ATTREZZATURE E MATERIALI UTILIZZATI NEL TRASPORTO DI MERCI',
  },
  { id: 17, desc: "MERCI TRASPORTATE NELL' AMBITO DI TRASLOCHI (UFFICI E ABITAZIONI)" },
  { id: 18, desc: 'MERCI RAGGRUPPATE' },
  { id: 19, desc: 'MERCI NON INDIVIDUABILI' },
  { id: 20, desc: 'ALTRE MERCI' },
])

export const cargoTypes = Object.freeze([
  { id: 1, desc: 'MERCI SFUSE (SOSTANZE LIQUIDE)' },
  { id: 2, desc: 'MERCI SFUSE (SOSTANZE SOLIDE)' },
  { id: 3, desc: 'CONTAINERS (DI GRANDI DIMENSIONI)' },
  { id: 4, desc: 'CONTAINERS (DI PICCOLE, MEDIE DIMENSIONI)' },
  { id: 5, desc: 'MERCI PALLETTIZZATE' },
  { id: 6, desc: 'MERCI PRE-IMBRAGATE' },
  { id: 7, desc: "UNITA' MOBILI, AUTOMOTRICI (DOTATE DI MOTORE ESEMPIO AUTOVETTURE)" },
  { id: 8, desc: "ALTRE UNITA' MOBILI" },
  { id: 9, desc: 'RISERVATO' },
  { id: 10, desc: 'ALTRI TIPI DI CARICO (ES. SCATOLE, BORSE, BIDONI)' },
])

export const dangerousTypes = Object.freeze([
  {
    id: 10,
    desc: 'Materie e oggetti esplosivi',
    items: ['Nitrocellulosa', 'Tritolo Trinitroclorobenzene', 'Detonatori', 'Fuochi d’artificio'],
    types: [8, 11],
  },
  {
    id: 20,
    desc: 'Gas compressi, liquefatti o disciolti sotto pressione',
    items: [
      'Argon',
      'Elio',
      'Neon',
      'Ossigeno',
      'Boro triflorato',
      'Deuterio',
      'Idrogeno',
      'Metano',
      'Monossido di carbonio',
      'Monossido di azoto',
      'Ossido di etilene',
      'Aria',
      'Ammoniaca 35-40%',
      'Accendini',
      'Estintori',
    ],
    types: [2],
  },
  {
    id: 30,
    desc: 'Materie liquide infiammabili',
    items: [
      'Benzina',
      'Benzene',
      'Etere di petrolio',
      'Etanolo',
      'Adesivi',
      'Vernici',
      'Gasoli',
      'Contenitori vuoti',
      'Acetone',
      'Inchiostri da stampa',
    ],
    types: [7, 8, 16],
  },
  {
    id: 41,
    desc: 'Materie solide infiammabili',
    items: ['Gomma', 'Fiammiferi', 'Pellicole in nitrocellulosa', 'Naftalina', 'Imballaggi vuoti'],
    types: [8, 16],
  },
  {
    id: 42,
    desc: 'Materie soggette ad esplosione spontanea',
    items: ['Carbone', 'Cartacarbone', 'Celluloide', 'Imballaggi vuoti'],
    types: [2, 6, 8, 16],
  },
  {
    id: 43,
    desc: 'Materie che, a contatto con acqua, liberano gas infiammabili',
    items: ['Cesio', 'Litio', 'Rubidio', 'Potassio', 'Sodio', 'Fosfato di calcio', 'Imballaggi vuoti'],
    types: [8, 16],
  },
  {
    id: 51,
    desc: 'Materie comburenti',
    items: ['Acido perclorico', 'Fertilizzanti azotati', 'Imballaggi vuoti'],
    types: [8, 16],
  },
  {
    id: 52,
    desc: 'Perossidi organici',
    items: ['Candeggina', 'Imballaggi vuoti'],
    types: [8, 16],
  },
  {
    id: 61,
    desc: 'Materie tossiche',
    items: ['Acido cianidrico', 'Nitrobenzene', 'Ossido di piombo'],
    types: [8],
  },
  {
    id: 62,
    desc: 'Materie suscettibili di produrre infezioni',
    items: [
      'Unghie',
      'Ossa',
      'Pelle fresca',
      'Urina non infetta',
      'Pezzi anatomici',
      'Letame',
      'Residui produzione della colla',
    ],
    types: [14],
  },
  { id: 70, desc: 'Materie radioattive', items: [], types: [10, 14] },
  {
    id: 80,
    desc: 'Materie corrosive',
    items: ['Acido nitrico', 'Acido fosforico', 'Soluzioni di ammoniaca'],
    types: [8],
  },
  {
    id: 90,
    desc: 'Materie e oggetti pericolosi diversi',
    items: ['Batterie al litio', 'Apparecchi contenenti aria compressa', 'Apparecchi salva-vita'],
    types: [1, 14],
  },
])

export const vehicleAxlesTypes = Object.freeze([
  { id: 120, desc: 'Autocarro - 2 assi' },
  { id: 130, desc: 'Autocarro - 3 assi' },
  { id: 140, desc: 'Autocarro - 4 assi' },
  { id: 199, desc: 'Autocarro - altri' },
  { id: 221, desc: 'Autocarro e rimorchio - 2 + 1 assi' },
  { id: 222, desc: 'Autocarro e rimorchio - 2 + 2 assi' },
  { id: 223, desc: 'Autocarro e rimorchio - 2 + 3 assi' },
  { id: 232, desc: 'Autocarro e rimorchio - 3 + 2 assi' },
  { id: 233, desc: 'Autocarro e rimorchio - 3 + 3 assi' },
  { id: 299, desc: 'Autocarro e rimorchio - altri' },
  { id: 321, desc: 'Trattore stradale e semirimorchio - 2 + 1 assi' },
  { id: 322, desc: 'Trattore stradale e semirimorchio - 2 + 2 assi' },
  { id: 323, desc: 'Trattore stradale e semirimorchio - 2 + 3 assi' },
  { id: 332, desc: 'Trattore stradale e semirimorchio - 3 + 2 assi' },
  { id: 333, desc: 'Trattore stradale e semirimorchio - 3 + 3 assi' },
  { id: 399, desc: 'Trattore stradale e semirimorchio - altri' },
  { id: 499, desc: 'Trattore stradale singolo' },
])

export const placeTypes = Object.freeze([
  { id: 'D', desc: 'Deposito' },
  { id: 'I', desc: 'Interporto' },
  { id: 'P', desc: 'Porto' },
  { id: 'A', desc: 'Aeroporto' },
  { id: 'S', desc: 'Stazione ferroviaria' },
  { id: 'X', desc: 'Altro' },
])

export const coupledVehicleTypes = Object.freeze([
  { id: 1, desc: 'Rimorchio' },
  { id: 2, desc: 'Semirimorchio' },
])

export const embarkingTypes = Object.freeze([
  // { id: 0, desc: 'no' },
  { id: 1, desc: 'nave' },
  { id: 2, desc: 'treno' },
])

export const Helper = (types) => ({
  findById: (id) => (id ? types.find((item) => item.id === id) : null),
  getDescById: (id) => (id ? types.find((item) => item.id === id) : null)?.desc,
  toItems: () => types.map(({ id: value, desc: text }) => ({ value, text })),
})
